module.exports = __webpack_public_path__ + "img/logo_MNC_group_original-01.4512a13e.png";